import { render, staticRenderFns } from "./ShowDetails.vue?vue&type=template&id=77437ec7&scoped=true&"
import script from "./ShowDetails.vue?vue&type=script&lang=js&"
export * from "./ShowDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShowDetails.vue?vue&type=style&index=0&id=77437ec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77437ec7",
  null
  
)

export default component.exports